import { render, staticRenderFns } from "./administrative.vue?vue&type=template&id=535f9ff1&scoped=true&"
import script from "./administrative.vue?vue&type=script&lang=js&"
export * from "./administrative.vue?vue&type=script&lang=js&"
import style0 from "./administrative.vue?vue&type=style&index=0&id=535f9ff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f9ff1",
  null
  
)

export default component.exports